<template>
    <div style="height: 98%;">
        <div class="crumbs mcrumb-self">
			<el-breadcrumb separator="-">
				<el-breadcrumb-item>
					<i class="el-icon-user"></i><span>系统设置</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item><span>用户管理</span></el-breadcrumb-item>
			</el-breadcrumb>
		</div>
        <!-- <el-divider></el-divider> -->
        <div class="container" style="padding: 15px;height: 92%;">
            <div style="padding-bottom: 10px;">
                <el-row type="flex">
                    <el-col :span="8">
                        <el-button type="primary" style="width: 80px" @click="userDetailClickFun('0', '')">新增</el-button>
                        <el-button plain style="width: 80px" @click="deleteUsersClickFun()">删除</el-button>
                    </el-col>
                    <el-col :span="16" style="text-align: right;">
                        <el-input v-model="userSearchName" placeholder="搜索姓名、用户名、手机、邮箱" prefix-icon="el-icon-search" @keyup.native="advanceQueryUserData()" style="width: 350px"/>
                    </el-col>
                </el-row>
            </div>
            <div style="height: 94%;">
                <el-table :data="userTableData" border stripe height="90%" class="table" ref="userTable" highlight-current-row @row-click="clickRowByChecked">
                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                    <el-table-column prop="id" v-if="showColumn"></el-table-column>
                    <el-table-column prop="userName" label="姓名" sortable></el-table-column>
                    <el-table-column prop="userCode" label="用户名" sortable></el-table-column>
                    <el-table-column prop="companyNames" label="关联实体" sortable show-overflow-tooltip ></el-table-column>
                    <el-table-column prop="roleName" label="用户角色"></el-table-column>
                    <el-table-column prop="roleType" v-if="showColumn"></el-table-column>
                    <el-table-column prop="state" label="当前状态" :formatter="this.formatStatus"></el-table-column>
                    <el-table-column prop="phone" label="手机" sortable></el-table-column>
                    <el-table-column prop="email" label="邮箱" sortable show-overflow-tooltip></el-table-column>
                    <el-table-column prop="operate" label="操作" width="120" align="center" fixed="right">
                        <template slot-scope="scoped">
                            <el-button size="small" type="text" @click="userDetailClickFun('2', scoped.row)">查看</el-button>
                            <el-button size="small" type="text" @click="userDetailClickFun('1', scoped.row)">编辑</el-button>
                            <el-button size="small" type="text" @click="deleteUserClickFun(scoped.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pwm.page"
                        :page-size="pwm.limit"
                        :page-sizes="pwm.limits"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pwm.count">
                    </el-pagination>
                </div>
            </div>
        </div>

        <!-- 查看、编辑、新增用户 -->
        <el-dialog :title="userManageTitle" :visible.sync="userManageDialogVisible" width="55%" class="dialog" :close-on-click-modal="false">
            <div class="custom-dialog">
                <el-form :model="userManageForm" ref="userManageForm" :rules="userFormRule">
                    <el-input v-if="hideId == true" v-model="userManageForm.id"></el-input>
                    <el-input v-if="hideId == true" v-model="userManageForm.companyGroupId"></el-input>
                    <div style="padding-bottom: 15px;">
                        <div style="display: flex;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 姓名</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="userName">
                                        <el-input v-model="userManageForm.userName" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 用户名</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="userCode">
                                        <el-input v-model="userManageForm.userCode" :disabled="disabledUserCode"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                         <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>手机号</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="phone">
                                        <el-input v-model="userManageForm.phone" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>邮箱</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="email">
                                        <el-input v-model="userManageForm.email" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 密码</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="password">
                                        <el-input v-model="userManageForm.password" show-password :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 确认密码</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="repassword">
                                        <el-input v-model="userManageForm.repassword" show-password :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>用户类型</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="userType">
                                        <el-select v-model="userManageForm.userType" placeholder="请选择" style="width: 100%;" disabled>
                                            <el-option
                                                v-for="item in userTypeData"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 用户角色</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="roleId">
                                        <el-select v-model="userManageForm.roleId" placeholder="请选择" style="width: 100%;"  :disabled="disabledRole">
                                            <el-option
                                                v-for="item in roleComboData"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>集团名称</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="groupName">
                                        <el-input v-model="userManageForm.groupName" disabled></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>集团编号</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="groupNo">
                                        <el-input v-model="userManageForm.groupNo" disabled></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>当前状态</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="status">
                                        <el-select v-model="userManageForm.state" placeholder="请选择" style="width: 100%;" :disabled="disabled">
                                            <el-option
                                                v-for="item in statusData"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;"></div>
                        </div>
                    </div>
                    <div style="padding-left: 15px;">
                        <span class="ar-title">关联实体信息</span>
                        <div style="padding-top: 10px;" v-if="showRelCompanyOpBtn == true">
                            <el-button plain style="width: 80px;" @click="addRelCompanyClickFun()">添加</el-button>
                            <el-button plain style="width: 80px;" @click="delRelCompanyClickFun()">删除</el-button>
                        </div>
                        <div style="padding-top: 10px;">
                            <el-table :data="userManageForm.companyList" border stripe height="250px" class="table" ref="relCompanyTable" @row-click="clickUserRelCompanyRowByChecked">
                                <el-table-column type="selection" width="55" align="center" label="序号"></el-table-column>
                                <el-table-column prop="id" v-if="showColumn"></el-table-column>
                                <el-table-column prop="name" label="实体名称" sortable show-overflow-tooltip></el-table-column>
                                <el-table-column prop="taxNumber" label="实体税号" sortable show-overflow-tooltip></el-table-column>
                                <el-table-column prop="state" label="当前状态" :formatter="formatStatus"></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveUserDataClickFun('userManageForm')" style="width: 80px;" v-if="showSaveBtn">保存</el-button>
                <el-button @click="userManageDialogVisible = false" style="width: 80px;">返回</el-button>
            </span>
        </el-dialog>

        <!-- 关联实体信息 - 实体信息显示 -->
        <el-dialog title="公司信息" :visible.sync="showCompanyDataDialogVisible" width="40%" class="dialog" :close-on-click-modal="false">
            <div class="custom-dialog">
                <div style="padding-top: 10px;">
                    <el-table :data="userRelCompanyData" border stripe height="300px" class="table" ref="companyTable" @row-click="clickCompanyTableRowByChecked">
                        <el-table-column type="selection" width="55" align="center"></el-table-column>
                        <el-table-column prop="id" v-if="showColumn"></el-table-column>
                        <el-table-column prop="name" label="实体名称" sortable show-overflow-tooltip></el-table-column>
                        <el-table-column prop="taxNumber" label="实体税号" sortable show-overflow-tooltip></el-table-column>
                        <el-table-column prop="state" label="当前状态" :formatter="formatStatus"></el-table-column>
                    </el-table>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveUserRelCompanyClickFun()" style="width: 80px;">保存</el-button>
                <el-button @click="showCompanyDataDialogVisible = false" style="width: 80px;">返回</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import https, { fetchPost } from '../../../../https.js';
    export default {
        data() {
            return {
                pwm: {
                    count: 0,
                    limit: 10,
                    page: 1,
                    limits: [10, 20, 50, 100]
                },
                userSearchName: '',
                showColumn: false,  //  id列是否隐藏
                hideId: false,  //  form 隐藏字段
                showSaveBtn: false, //  dialog 保存按钮是否隐藏
                showRelCompanyOpBtn: false,
                userTableData: [],
                userManageTitle: '',
                userManageDialogVisible: false,
                userOpUrl: '',
                userTypeData: [
                    {
                        value: '1',
                        label: '集团管理员'
                    },
                    {
                        value: '2',
                        label: '集团用户'
                    }
                ],
                roleComboData: [],
                userManageForm: {
                    id: '',
                    userName: '',
                    phone: '',
                    userCode: '',
                    email: '',
                    password: '',
                    repassword: "",
                    userType: '',
                    roleId: '',
                    groupName: '',
                    groupNo: '',
                    state: '0',
                    companyList: []
                },
                userFormRule: { //  form 校验规则
                    // userName: [
                    //     { required: true, message: '请输入姓名', trigger: 'blur' },
                    //     { max: 10, message: '姓名不得超过10个字符' }
                    // ],
                    userCode: [
                        { required: true, message: '请输入用户名', trigger: 'blur' },
                        { max: 40, message: '用户名不得超过40个字符' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { min: 6, max: 30, message: '密码错误，长度为6~30位之间' }
                    ],
                    repassword: [
                        { required: true, message: '请输入确认密码', trigger: 'blur' },
                        { validator: this.checkPassword, trigger: 'blur'}
                    ],
                    phone: [
                        { required: false, validator: this.checkMobile }
                    ],
                    email: [
                        {  required: false, validator: this.checkEmail }
                    ],
                    roleId: [
                        { required: true, message: '请选择用户角色', trigger: 'change' }
                    ]
                },
                userRelCompanyData: [],
                showCompanyDataDialogVisible: false,
                currGroupData: '',  //  当前集团信息
                allCompanyList: '', //  当前集团下所有实体信息
                disabled: false,    //  字段是否禁用
                disabledUserCode: false,    //  用户名是否禁用
                disabledRole: false //  用户角色是否禁用
            }
        },
        created: function() {
            //  curr group data
            //  使用.then()函数：当这个函数执行完后在执行下个函数
            this.getCurrentGroupData().then(val => {
                this.getUserTableData();    //  load table data
                this.getCompanyDataByCurrGroupId(this.currGroupData.id);
            }); 
        },
        mounted: function() {
        },
        methods: {
            handleSizeChange(val) {
                this.pwm.limit = val;
                this.getUserTableData();
            },
            handleCurrentChange(val) {
                this.pwm.page = val;
                this.getUserTableData();
            },
            clickRowByChecked(row) {
                this.$refs.userTable.toggleRowSelection(row);
            },
            clickUserRelCompanyRowByChecked(row) {
                this.$refs.relCompanyTable.toggleRowSelection(row);
            },
            clickCompanyTableRowByChecked(row) {
                this.$refs.companyTable.toggleRowSelection(row);
            },
            async getCurrentGroupData() { //  当前集团信息 : 同步执行
                await fetchPost('/sys/admin/getCurrentCompanyGroup', '').then(res => {
                    if(res.data.success) {
                        this.currGroupData = res.data.obj;
                    } else {
                        this.$message.error('获取当前集团信息错误：' + res.data.message);
                        return;
                    }
                }, error => {
                    this.$message.error('获取当前集团信息错误：' + error);
                });
            },
            getUserTableData: function() {  //  load user table data
                this.pwm.search = { 'groupId': this.currGroupData.id };
                // fetchPost('/sys/admin/getUserList', this.pwm).then(res => {
                fetchPost('/sys/main/getUserListByCurrCompanyGroup', this.pwm).then(res => {
                    this.userTableData = res.data.data;
                    this.pwm.count = res.data.count;
                    this.advanceQueryUserData()
                }, error => {
                    this.$message.error('加载用户信息失败：' + error);
                });
            },
            async getCompanyDataByCurrGroupId(groupId) { //  用户勾选关联公司：company data
                // await fetchPost('/sys/admin/getCompanyListByGroup', groupId).then(res => {
                await fetchPost('/sys/main/getUserBeLongsCompanyList', groupId).then(res => {
                    if(res.data.success) {
                        this.allCompanyList = res.data.obj;
                    } else {res.data.data;
                        this.$message.error('获取当前集团下所有实体信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('获取当前集团下所有实体信息失败：' + error);
                });
            },
            getRoleListByGroupId(groupId, opType) { //  获取当前集团下的所有用户角色数据
                fetchPost('/sys/admin/getRoleListByCompanyGroup', groupId).then(res => {
                    if(res.data.success) {
                        this.assembleRoleComboData(res.data.obj, opType);
                    } else {
                        this.$message.error('加载当前集团下用户角色信息错误：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('加载当前集团下用户角色信息错误：' + error);
                });
            },
            async assembleRoleComboData(roleData, opType) {   //  拼接用户角色下拉数据
                let roleComboData = [];
                if(roleData && roleData.length > 0) {
                    roleData.forEach(roleObj => {
                        roleComboData.push({value: roleObj.id, label: roleObj.roleName});
                    });
                    if(opType == '0' && roleComboData && roleComboData.length > 0) {
                         //  新增时过滤掉’集团管理员‘角色
                        roleComboData = roleComboData.filter(roleObj => {
                            return roleObj.label != '集团管理员';
                        });
                        this.userManageForm.roleId = roleComboData[0].value;
                    }
                }
                this.roleComboData = roleComboData;
            },
            getUserDataById(rowData) {   //  查看详情
                fetchPost('/sys/admin/getUserById', rowData.id).then(res => {
                    if(res.data.success) {
                        let objList =res.data.obj
                        objList.repassword=objList.password
                        this.userManageForm = objList ;
                        this.userManageForm.groupName = this.currGroupData.name;
                        this.userManageForm.groupNo = this.currGroupData.code;
                        this.userManageDialogVisible = true;
                    } else {
                        this.$message.error('加载用户信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('加载用户信息失败：' + error);
                });
            },
            advanceQueryUserData() {
                let pwm = this.pwm;
                pwm.likeSearch = this.userSearchName;
                fetchPost('/sys/admin/getUserList', this.pwm).then(result => {
                    this.userTableData = result.data.data;
                    this.pwm.count = result.data.count;
                }).catch (error => {
                    this.$message.error(error);
                });
            },
            userDetailClickFun(opType, rowData) {  //  新增、编辑 dialog
                Object.keys(this.userManageForm).map(key => (this.userManageForm[key] = ''));
                this.userManageForm.companyList = [];
                this.$nextTick(() => {
                    if(this.$refs.userManageForm) {
                        this.$refs.userManageForm.clearValidate();   //  重置表单校验
                    }
                });
                this.getCompanyDataByCurrGroupId(this.currGroupData.id);
                //  load 用户角色下拉数据
                this.getRoleListByGroupId(this.currGroupData.id, opType);
                if(opType == '0') {
                    this.userManageTitle = '新增用户信息';
                    this.showSaveBtn = true;
                    this.showRelCompanyOpBtn = true;
                    this.disabled = false;
                    this.disabledUserCode = false;
                    this.disabledRole = false;
                    this.userManageForm.state = '0';
                    this.userManageForm.groupName = this.currGroupData.name;
                    this.userManageForm.groupNo = this.currGroupData.code;
                    this.userManageForm.userType = '2'; //  默认集团用户
                    this.userManageDialogVisible = true;
                    this.userOpUrl = '/sys/admin/addUser';
                } else if(opType == '1') {
                    this.userManageTitle = '编辑用户信息';
                    this.showSaveBtn = true;
                    this.showRelCompanyOpBtn = false;
                    this.disabled = false;
                    this.disabledUserCode = true;
                    //  当前编辑用户角色类型为集团管理员则不能编辑
                    if(rowData.roleType == '1') {
                        this.disabledRole = true;
                    } else {
                        this.disabledRole = false;
                    }
                    this.getUserDataById(rowData);
                    this.userOpUrl = '/sys/admin/updateUser';
                } else if(opType == '2') { 
                    this.userManageTitle = '查看用户信息';
                    this.showSaveBtn = false;
                    this.showRelCompanyOpBtn = false;
                    this.disabled = true;
                    this.disabledUserCode = true;
                    this.disabledRole = true;
                    this.getUserDataById(rowData);
                }
            },
            addRelCompanyClickFun() {   //  新增用户关联公司信息
                this.showCompanyDataDialogVisible = true;
                //  过滤掉用户已关联的实体信息
                this.userRelCompanyData = this.allCompanyList;
                // this.userRelCompanyData = this.allCompanyList.filter(company => {
                //     let checkIdList = this.userManageForm.companyList.map(data => data.id);
                //     return !checkIdList .includes(company.id)
                // })
            },
            delRelCompanyClickFun() {   //  删除用户关联公司信息
                let checkRows = this.$refs.relCompanyTable.selection;
                if(!checkRows || checkRows.length == 0) {
                    this.$message.warning('请选择需要删除关联的公司信息！');
                    return;
                }
                let relCompanyData = this.userManageForm.companyList;
                this.userManageForm.companyList = relCompanyData.filter(company => {
                    let checkIdList = checkRows.map(row => row.id);
                    return !checkIdList.includes(company.id);
                });

                 this.allCompanyList = this.userRelCompanyData.concat(checkRows);
            },
            saveUserRelCompanyClickFun() {  //  保存用户勾选的公司信息
                let checkRows = this.$refs.companyTable.selection;
                if(!checkRows || checkRows.length == 0) {
                    this.$message.warning('请选择需要关联的公司信息！');
                    return;
                }
                let relCompanyData = this.userRelCompanyData;
                this.allCompanyList = relCompanyData.filter(company => {
                    let checkIdList = checkRows.map(row => row.id);
                    return !checkIdList.includes(company.id);
                });

                this.userManageForm.companyList = this.userManageForm.companyList.concat(checkRows);
                this.showCompanyDataDialogVisible = false;
            },
            saveUserDataClickFun(formName) {    //  保存用户数据
                this.$refs[formName].validate((valid) => {
                    if(!valid) {
                        return false;
                    }
                    let userData = this.userManageForm;
                    userData.companyGroupId = this.currGroupData.id;
                    let companyIdList = [];
                    let userCheckCompanyData = userData.companyList;
                    if(!userCheckCompanyData || userCheckCompanyData.length == 0) {
                        this.$message.warning('请选择用户所关联的实体信息！');
                        return;
                    }
                    userCheckCompanyData.forEach(company => {
                        companyIdList.push(company.id);
                    });
                    userData.companyIds = companyIdList.join(',');

                    fetchPost(this.userOpUrl, userData).then(res => {
                        if(res.data.success) {
                            this.$message.success('保存用户信息成功！');
                            this.userManageDialogVisible = false;   //  关闭dialog
                            this.userManageForm.companyList = [];
                            //  reload user table
                            this.getUserTableData();
                        } else {
                            this.$message.error('保存用户信息失败：' + res.data.message);   
                        }
                    }, error => {
                        this.$message.error('保存用户信息失败：' + error);
                    });
                });
            },
            deleteUserClickFun(userData) {  //  单条删除
                this.$confirm('是否删除当前选中的用户信息？', '提示', { type: 'warning'}).then(res => {
                    this.deleteUser(userData.id);
                });
            },
            deleteUsersClickFun() { //  删除用户信息 (批量)
                let idList = [];
                let checkRows = this.$refs.userTable.selection;
                 if(!checkRows || checkRows.length == 0) {
                    this.$message.warning('请选择需要删除的用户信息！');
                    return;
                }
                checkRows.forEach(row => {
                    idList.push(row.id);
                });
                this.$confirm('是否删除当前选中用户信息？', '提示', { type: 'warning'}).then(res => {
                    this.deleteUser(idList.join(','));
                });
            },
            deleteUser(ids) {  //  删除操作
                fetchPost('/sys/admin/deleteUsers', ids).then(res => {
                    if(res.data.success) {
                        this.$message.success('删除用户信息成功！');
                        //  reload user table
                        this.getUserTableData();
                    } else {
                        this.$message.error('删除用户信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('删除用户信息失败：' + error);
                });
            },
            checkPassword(rule, value, cb) {    //  确认密码校验
                if(this.userManageForm.password != value) {
                    cb(new Error('确认密码与密码不一致'));
                } else {
                    return cb()
                }
            }
        }
    }
</script>

<style scoped>
    .table {
        width: 100%;
        font-size: 14px;
    }
    .el-dialog {
        margin: 0 auto !important;
    }
    .el-dialog__header {
        padding: 0 !important;
    }

    .el-dialog__wrapper {
        display: flex ;
        align-items: center ;
        
    }
</style>